var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.295 13.5742C5.49497 13.5742 3.09497 14.9742 3.09497 17.7742C3.09497 19.3742 4.29497 20.5742 5.79497 20.5742H14.795C16.295 20.5742 17.395 19.4742 17.495 17.7742C17.495 14.9742 15.095 13.5742 10.295 13.5742Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.995 13.674C18.495 13.474 17.895 13.774 17.695 14.274C17.495 14.774 17.795 15.374 18.295 15.574C19.795 16.074 19.995 16.874 19.995 17.574C19.995 18.074 19.695 18.674 18.995 18.674C18.395 18.674 17.995 19.074 17.995 19.674C17.995 20.274 18.395 20.674 18.995 20.674C20.695 20.674 21.995 19.374 21.995 17.574C22.095 16.174 21.595 14.474 18.995 13.674Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99487 3.87305C12.2039 3.87305 13.9949 5.66405 13.9949 7.87305C13.9949 10.082 12.2039 11.873 9.99487 11.873C7.78587 11.873 5.99487 10.082 5.99487 7.87305C5.99487 5.66405 7.78587 3.87305 9.99487 3.87305Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4949 9.97319C14.9949 10.1732 14.7949 10.7732 14.9949 11.2732C15.1949 11.6732 15.4949 11.8732 15.8949 11.8732C15.9949 11.8732 16.1949 11.8732 16.2949 11.7732C17.8949 11.0732 18.7949 9.67319 18.7949 8.07319C18.7949 6.37319 17.7949 4.87319 16.1949 4.37319C15.6949 4.17319 15.0949 4.47319 14.8949 4.97319C14.6949 5.47319 14.9949 6.07319 15.4949 6.27319C16.1949 6.57319 16.6949 7.27319 16.6949 8.17319C16.7949 9.27319 15.8949 9.77319 15.4949 9.97319Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.1e7c4b78142324543b1e1d5691898c52.svg";
export { ForwardRef as ReactComponent };